import React, { useState } from 'react';
import TabSwitcher from './TabSwitcher';
import OverviewTab from './overview/OverviewTab';
import ProgressTab from './progress/ProgressTab';
import CheckInsTab from './checkins/CheckInsTab';
import RecordsTab from './records/RecordsTab';

/**
 * Owns which of the 4 Stats tabs is active. Local state only, no URL sync —
 * matches the sub-tab navigation pattern the old 3-tab EnhancedStats.jsx used.
 * The outer screen header/back-button chrome lives in EnhancedStats.jsx, not
 * here — this component is just the tab strip + active tab's content.
 *
 * A tab once opened stays loaded and is only hidden: going back to it showed it again from nothing,
 * about 21 reads for Overview each time (Codex's task 017 review, 21 October 2026). Leaving Stats
 * clears them, so numbers are fresh after a workout.
 */
const StatsShell = ({ userId, programId, onStartWorkout, initialTab = 'overview' }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [opened, setOpened] = useState(() => new Set([initialTab]));
  const open = (tab) => {
    setOpened((was) => (was.has(tab) ? was : new Set(was).add(tab)));
    setActiveTab(tab);
  };
  const panel = (tab, content) => opened.has(tab) && <div hidden={activeTab !== tab}>{content}</div>;

  return (
    <div>
      <TabSwitcher activeTab={activeTab} onTabChange={open} />

      {panel('overview', (
        <OverviewTab
          userId={userId}
          programId={programId}
          onViewRecords={() => open('records')}
          onStartWorkout={onStartWorkout}
        />
      ))}
      {panel('progress', <ProgressTab userId={userId} />)}
      {panel('checkins', <CheckInsTab userId={userId} onStartWorkout={onStartWorkout} />)}
      {panel('records', <RecordsTab userId={userId} />)}
    </div>
  );
};

export default StatsShell;
